import FullscreenError from './fullscreen-error';

import './fullscreen-error.scss';

export default FullscreenError;
